import useIsMobileDevice from '../hooks/useIsMobileDevice';

const CartItemCard = ({ item }) => {
    const isMobileDevice = useIsMobileDevice();
    return (
      <div className={`${isMobileDevice ? 'w-[90%]' : 'w-[98%]'} flex flex-row mb-2  p-2 min-h-[150px] border border-gray-300 shadow-md rounded-md`}>
            {item.imageUrl && <img src={item.imageUrl} alt={item.name} className="w-28 h-28 object-cover rounded bg-gray-200 text-center mx-auto" />}
            <div className="flex-grow mx-4">
                <h3 className="text-lg font-semibold">{item.name || item.file.name}</h3>
                <div className="text-gray-500">{
                    item.description
                    ||
                    <div>
                        <ul className="list-disc list-inside">
                            <li>Paper format: {item.paperFormat}</li>
                            <li>Print Option: {item.printOption}</li>
                            <li>Print Color: {item.printColor}</li>
                            <li>Paper Orientation: {item.paperOrientation}</li>
                            <li>Add Cover Page: {item.addCoverPage ? 'Yes' : 'No'}</li>
                            <li>Paper Fastening: {item.paperFasteningChoice}</li>
                            <li>Page Range: {item.pageRange}</li>
                            {item.additionalNotes && <li>Additional Notes: {item.additionalNotes}</li>}
                        </ul>
                     </div>
                }</div>
                <h1 className='text-lg font-bold text-green-400'>DA {item.price}</h1>
            </div>
      </div>
    );
  }

export default CartItemCard;